import { performDeleteRequest } from '@atlassian/jira-fetch/src/index.tsx';
import type { IssueTypeId, ProjectId } from '@atlassian/jira-shared-types/src/general.tsx';

export const performDeleteIssueType = (issueTypeId: IssueTypeId, projectId: ProjectId) => {
	return performDeleteRequest(
		`/rest/polaris/v2/project/${projectId}/settings/issuetype/${issueTypeId}`,
	);
};
